import { MARKETPLACE_BUSINESS_LINE } from "@swiggy-private/payment-types";

export const PAYMENT_MODES_STORAGE_KEYS = {
    ADD_NEW_CARD: "add_card_details",
    MANAGE_CARD: "manage_card_details",
    CARD_DETAILS: "card_details",
};

export const CARTKEY_PAYMENT_OPTIONS_ELIGIBLE_BUSINESS_LINES = new Set([
    MARKETPLACE_BUSINESS_LINE.DASH,
    MARKETPLACE_BUSINESS_LINE.POST_ORDER_TIP,
    MARKETPLACE_BUSINESS_LINE.DINEOUT,
    MARKETPLACE_BUSINESS_LINE.PAY_ON_DELIVERY,
    MARKETPLACE_BUSINESS_LINE.HANDPICKED,
    MARKETPLACE_BUSINESS_LINE.ASSURE,
    MARKETPLACE_BUSINESS_LINE.JUST,
]);
